import { Injectable } from '@angular/core';
import { ExpirationInterface, TIME_UNITS } from '../types';

const SECONDS_IN_A_DAY = 86400;
const SECONDS_IN_AN_HOUR = 3600;
const SECONDS_IN_A_MINUTE = 60;

@Injectable()
export class TimeConversionService {
  private units = [
    { unit: TIME_UNITS.DAYS, seconds: SECONDS_IN_A_DAY },
    { unit: TIME_UNITS.HOURS, seconds: SECONDS_IN_AN_HOUR },
    { unit: TIME_UNITS.MINUTES, seconds: SECONDS_IN_A_MINUTE },
  ];

  parsePurchaseExpiration(seconds?: number): ExpirationInterface {
    if (!seconds) return { unit: TIME_UNITS.MINUTES, value: null };

    for (const { unit, seconds: unitSeconds } of this.units) {
      if (seconds % unitSeconds === 0) {
        return { unit, value: seconds / unitSeconds };
      }
    }

    return { unit: TIME_UNITS.SECONDS, value: seconds };
  }

  convertToSeconds(value: number | null, unit: TIME_UNITS): number | null {
    if (!value) return null;
    switch (unit) {
      case TIME_UNITS.DAYS:
        return Number(value) * SECONDS_IN_A_DAY;
      case TIME_UNITS.HOURS:
        return Number(value) * SECONDS_IN_AN_HOUR;
      case TIME_UNITS.MINUTES:
        return Number(value) * SECONDS_IN_A_MINUTE;
      case TIME_UNITS.SECONDS:
        return value;
      default:
        return null;
    }
  }
}
